import React, { useState } from "react";
import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  Typography,
  Grid,
  Avatar,
  Paper,
  Stack,
  IconButton,
  TextField,
  Button,
  Snackbar,
  Alert,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Box,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import RiderServices from "../services/externalServices/riderServices";

function VehicleDetails({ riderDetails,onDetailsUpdated }) {
  const [isEditing, setIsEditing] = useState(false);
  const [vehicleData, setVehicleData] = useState({ ...riderDetails });
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const defaultVehicle360View = [
  {
    frontView: "",
    rearView: "",
    rightView: "",
    leftView: "",
    // topView: "",
    interiorView_1: "",
    interiorView_2: "",
    interiorView_3: "",
    // interiorView_4: "",
  },
];
  console.log("VehicleDetails", riderDetails);

  // Handle input change for editable fields
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setVehicleData((prev) => {
      if (name.includes(".")) {
        const keys = name.split(".");
        return {
          ...prev,
          [keys[0]]: {
            ...prev[keys[0]],
            [keys[1]]: value,
          },
        };
      }
      return { ...prev, [name]: value };
    });
  };

  const handleDropdownChange = (e, key) => {
    setVehicleData((prev) => ({
      ...prev,
      [key]: e.target.value === "Yes",
    }));
  };

  // Save function
  const onSave = async (updatedData) => {
    setLoading(true);
    try {
      const response = await RiderServices.updateRider(
        riderDetails._id,
        updatedData
      );
      console.log("Updated Rider:", response);
      setLoading(false);
      setSuccessMessage("Vehicle details updated successfully!");
      onDetailsUpdated(updatedData);
    } catch (error) {
      console.error("Error updating vehicle details:", error);
      setLoading(false);
      setErrorMessage("Failed to update vehicle details. Please try again.");
    }
  };

  const handleSave = () => {
    onSave(vehicleData);
    setIsEditing(false);

  };

  return (
    <Card>
      <Stack direction="row" spacing={2} alignItems="center">
        <Paper
          elevation={3}
          style={{
            backgroundColor: "white",
            width: 50,
            height: 50,
            borderRadius: "50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginLeft: "3px",
          }}
        >
          <Avatar style={{ backgroundColor: "white" }}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="24px"
              viewBox="0 -960 960 960"
              width="24px"
              fill="#5f6368"
            >
              <path d="M549-120 280-400v-80h140q53 0 91.5-34.5T558-600H240v-80h306q-17-35-50.5-57.5T420-760H240v-80h480v80H590q14 17 25 37t17 43h88v80h-81q-8 85-70 142.5T420-400h-29l269 280H549Z" />
            </svg>
          </Avatar>
        </Paper>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography variant="h6" color="#667085">
                Vehicle Details
              </Typography>
              <IconButton
                size="small"
                onClick={() => setIsEditing(!isEditing)}
                style={{ marginLeft: "auto" }}
              >
                {isEditing ? <CloseIcon /> : <EditIcon />}
              </IconButton>
            </Stack>
          }
        />
      </Stack>
      <Divider />
      <CardContent>
        <Grid container spacing={2} marginTop={2}>
          {/* Vehicle Details */}
          {[
            { label: "Vehicle Name", key: "vehicle_name" },
            { label: "Vehicle Number", key: "vehicle_number" },
            { label: "Vehicle Class", key: "vehicleClass" },
            { label: "Vehicle Color", key: "vehicleColor" },
            { label: "Seating Capacity", key: "vehicleSeatingCapacity" },
          ].map(({ label, key }) => (
            <Grid item xs={12} sm={6} key={key}>
              <Typography variant="body2" color="#667085">
                {label}:
              </Typography>
              {isEditing ? (
                <TextField
                  name={key}
                  value={vehicleData[key] || ""}
                  onChange={handleInputChange}
                  fullWidth
                  size="small"
                />
              ) : (
                <Typography variant="subtitle2">
                  {vehicleData[key] || "N/A"}
                </Typography>
              )}
            </Grid>
          ))}

          {/* Boolean Field - Yellow Board */}
          <Grid item xs={12} sm={6}>
            <Typography variant="body2" color="#667085">
              Yellow Board:
            </Typography>
            {isEditing ? (
              <FormControl fullWidth size="small">
                <InputLabel id="yellow-board-select-label">Select</InputLabel>
                <Select
                  labelId="yellow-board-select-label"
                  value={vehicleData.vehicleIsYellowBoard ? "Yes" : "No"}
                  onChange={(e) =>
                    handleDropdownChange(e, "vehicleIsYellowBoard")
                  }
                >
                  <MenuItem value="Yes">Yes</MenuItem>
                  <MenuItem value="No">No</MenuItem>
                </Select>
              </FormControl>
            ) : (
              <Typography variant="subtitle2">
                {vehicleData.vehicleIsYellowBoard ? "Yes" : "No"}
              </Typography>
            )}
          </Grid>


          {(vehicleData.vehicle360View && vehicleData.vehicle360View.length > 0
            ? vehicleData.vehicle360View
            : defaultVehicle360View
          ).map((view, index) =>
            Object.entries(view)
              .filter(([key]) => key !== "_id")
              .map(([key, value]) => (
                <Grid item xs={12} sm={6} key={`${key}-${index}`}>
                  <Typography variant="body2" color="#667085">
                    {key.replace(/_/g, " ").replace("View", " View")}:
                  </Typography>
                  {isEditing ? (
                    <TextField
                      name={`vehicle360View.${key}`}
                      value={value || ""}
                      // onChange={(e) => {
                      //   const updatedValue = e.target.value;
                      //   setVehicleData((prev) => {
                      //     const updatedVehicle360View =
                      //       prev.vehicle360View &&
                      //       prev.vehicle360View.length > 0
                      //         ? prev.vehicle360View.map((v, i) =>
                      //             i === index
                      //               ? { ...v, [key]: updatedValue }
                      //               : v
                      //           )
                      //         : [{ [key]: updatedValue }];
                      //     return {
                      //       ...prev,
                      //       vehicle360View: updatedVehicle360View,
                      //     };
                      //   });
                      // }}
                      onChange={(e) => {
                        const updatedValue = e.target.value;
                        setVehicleData((prev) => {
                          const updatedVehicle360View =
                            prev.vehicle360View &&
                            prev.vehicle360View.length > 0
                              ? prev.vehicle360View.map((v, i) =>
                                  i === index
                                    ? { ...v, [key]: updatedValue } // Update only the edited field, keep others intact
                                    : v
                                )
                              : defaultVehicle360View.map((v, i) =>
                                  i === index
                                    ? { ...v, [key]: updatedValue } // Ensure default values are retained
                                    : v
                                );
                          return {
                            ...prev,
                            vehicle360View: updatedVehicle360View,
                          };
                        });
                      }}
                      fullWidth
                      size="small"
                    />
                  ) : value ? (
                    <Box
                    component="img"
                    src={value}
                    alt={key}
                    sx={{
                      width: "100%",
                      height:"300px",
                      // aspectRatio: "100px",     // Enforce a 16:9 aspect ratio (or whatever ratio suits your needs)
                      objectFit: "cover",      // Ensure the image covers the space
                      borderRadius: 1,
                      border: "1px solid #ddd",

                      }}
                    />
                  ) : (
                    <Typography variant="subtitle2">N/A</Typography>
                  )}
                </Grid>
              ))
          )}

         
        </Grid>

        {isEditing && (
          <Stack direction="row" justifyContent="flex-end" spacing={2} mt={3}>
            <Button
              variant="contained"
              color="primary"
              startIcon={<SaveIcon />}
              onClick={handleSave}
            >
              {loading ? "Saving..." : "Save"}
            </Button>
          </Stack>
        )}
      </CardContent>

      {/* Success and Error Messages */}
      <Snackbar
        open={Boolean(successMessage)}
        autoHideDuration={3000}
        onClose={() => setSuccessMessage("")}
      >
        <Alert
          onClose={() => setSuccessMessage("")}
          severity="success"
          sx={{ width: "100%" }}
        >
          {successMessage}
        </Alert>
      </Snackbar>

      <Snackbar
        open={Boolean(errorMessage)}
        autoHideDuration={3000}
        onClose={() => setErrorMessage("")}
      >
        <Alert
          onClose={() => setErrorMessage("")}
          severity="error"
          sx={{ width: "100%" }}
        >
          {errorMessage}
        </Alert>
      </Snackbar>
    </Card>
  );
}

export default VehicleDetails;
